import React, { memo } from "react";
import { motion } from "framer-motion";
import { Heart, Eye, BadgeCheck } from "lucide-react";
/* ================= REUSABLE ANIMATION ================= */
const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0 },
};

/* ================= REUSABLE IMAGE ================= */
const LazyImage = memo(({ src, alt, className }) => (
  <img loading="lazy" src={src} alt={alt} className={className} />
));

export default function AboutUs() {

  

const cards = [
  {
    title: "Values",
    icon: <Heart size={52} color="#c9961a" strokeWidth={1.5} />,
    text: "State of the art facility with hygienic, automated manufacturing.",
  },
  {
    title: "Vision",
    icon: <Eye size={52} color="#c9961a" strokeWidth={1.5} />,
    text: "World-class research and innovation for global markets.",
  },
  {
    title: "Quality",
    icon: <BadgeCheck size={52} color="#c9961a" strokeWidth={1.5} />,
    text: "Highest quality products meeting global hygiene standards.",
  },
];


  const historyData = [
    {
      year: "2018",
      title: "Founded Company",
      desc: "Company was founded in Nov 2, 2018",
      position: "top",
    },
    {
      year: "2019",
      title: "Confidays",
      desc: "Installed Capacity of 1 Lakh",
      position: "bottom",
    },
    {
      year: "2020",
      title: "Confidays",
      desc: "Establishing a world class manufacturing unit with 50+ women staff",
      position: "top",
    },
    {
      year: "2022",
      title: "Confidays",
      desc: "More than 10,000 users, association with NGO’s",
      position: "bottom",
    },
  ];

  const statsData = [
    { value: "4+", label: "Years Of Experience & Record" },
    { value: "30+", label: "Systems Installed" },
    { value: "3.5k", label: "Happy, Satisfied Users" },
    { value: "4.9+", label: "Customer Ratings" },
  ];

  return (
    <main className="w-full font-poppins overflow-hidden mt-10 md:mt-0">
      {/* ================= HERO ================= */}
      <section className="bg-gradient-to-b from-[#6A1B9A] to-[#9C27B0] py-14 text-center text-white">
        <motion.div
          initial="hidden"
          animate="visible"
          variants={fadeUp}
          transition={{ duration: 0.5 }}
          className="max-w-7xl mx-auto px-4"
        >
          <div className="text-sm mb-3">
            <a href="/" className="hover:underline">
              Home
            </a>{" "}
            › About Us
          </div>

          <h1 className="text-4xl md:text-5xl font-bold">About Us</h1>
        </motion.div>
      </section>

      {/* ================= OUR STORY ================= */}
      <section className="py-16 lg:py-24">
        <div className="max-w-7xl mx-auto px-5 grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-20 items-center">
          {/* LEFT CONTENT */}
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeUp}
            transition={{ duration: 0.5 }}
          >
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-[var(--brand-dark)]">
              <span className="text-[var(--brand-purple)]">Our</span> Story
            </h2>

            <p className="text-[var(--brand-gray)] text-justify leading-8 mb-5">
              Confidays sanitary napkins are made from all-natural, renewable
              resources and have a low environmental impact. They’re also
              chemical free which means they won’t irritate your skin or give
              you any unpleasant experience when used for everyday protection.
            </p>

            <p className="text-[var(--brand-gray)] text-justify leading-8">
              There’s a reason we call it “confidays.” These days, we know that
              you can’t be too careful when it comes to your health and hygiene.
              Confidays is committed to making the world a better place by
              providing quality products that have an environmentally friendly,
              low-impact on resources.
            </p>
          </motion.div>

          {/* RIGHT IMAGE */}
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="flex justify-center"
          >
            <img
              loading="lazy"
              src="/about-us.png"
              alt="Confidays Care"
              className="
                relative
                z-10

                w-[280px]
                sm:w-[360px]
                lg:w-[430px]

                rounded-[34px]

                shadow-[0_20px_60px_rgba(236,72,153,0.15)]

                object-cover
              "
            />
          </motion.div>
        </div>
      </section>

      {/* ================= VALUES ================= */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-5 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {cards.map((item, i) => (
            <motion.div
              key={i}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={fadeUp}
              transition={{ duration: 0.4, delay: i * 0.1 }}
              className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-md transition-all duration-300 text-center"
            >
            <div className="flex justify-center mb-5">
  {item.icon}
</div>

              <h3 className="font-semibold text-xl mb-3">{item.title}</h3>

              <p className="text-sm text-[var(--brand-gray)] leading-7">
                {item.text}
              </p>
            </motion.div>
          ))}
        </div>
      </section>

      {/* ================= DIRECTOR MESSAGE ================= */}
      <section className="grid grid-cols-1 lg:grid-cols-2">
        {/* LEFT */}
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="relative text-white px-6 py-14 sm:px-10 lg:px-14 flex flex-col justify-center"
          style={{
            backgroundImage:
              "linear-gradient(rgba(31,47,143,0.92), rgba(31,47,143,0.92)), url('/226.webp')",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <h1 className="absolute top-8 left-6 text-6xl lg:text-8xl font-bold opacity-10 tracking-widest">
            STEPS
          </h1>

          <h2 className="text-3xl lg:text-4xl font-bold mb-5">
            Director’s Message
          </h2>

          <p className="opacity-90 mb-10 max-w-md leading-7">
            We sincerely thrive for quality up gradation, commitment, hard work
            and achieve goals
          </p>

          <div className="space-y-10">
            {[
              {
                no: "01",
                title: "Methodology",
                text: "Transparency, integrity and accountability",
              },
              {
                no: "02",
                title: "Explore our Products",
                text: "Highest quality sanitary napkin in the safest way",
              },
            ].map((step, i) => (
              <div key={i} className="flex gap-5">
                <div className="min-w-[42px] h-[42px] rounded-full bg-white text-[#1F2F8F] flex items-center justify-center font-bold">
                  {step.no}
                </div>

                <div>
                  <h4 className="font-semibold text-lg">{step.title}</h4>

                  <p className="opacity-80 text-sm mt-1">{step.text}</p>
                </div>
              </div>
            ))}
          </div>
        </motion.div>

        {/* RIGHT */}
        <div className="grid grid-cols-2 min-h-[320px]">
          {[
            { img: "/222.webp", title: "Our Values" },
            { img: "/223.webp", title: "Our Vision" },
          ].map((item, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
              className="relative overflow-hidden"
            >
              <LazyImage
                src={item.img}
                alt={item.title}
                className="w-full h-full object-cover hover:scale-105 transition-all duration-700"
              />

              <span className="absolute bottom-5 left-5 text-white font-semibold text-lg">
                {item.title}
              </span>
            </motion.div>
          ))}
        </div>
      </section>

      {/* ================= HISTORY ================= */}
      <section className="py-20 lg:py-24 text-center">
        <h2 className="text-4xl font-bold text-[#1F2F8F] mb-5">
          Confidays History
        </h2>

        <p className="max-w-4xl mx-auto text-gray-600 mb-20 px-4 leading-8">
          We are a group of people with experience in many fields who work
          together to provide women with sustainable options.
        </p>

        {/* DESKTOP */}
        <div className="hidden lg:block relative max-w-7xl mx-auto">
          <LazyImage src="/Arrow.webp" alt="timeline" className="w-full" />

          <div className="absolute inset-0 flex justify-between items-center px-10">
            {historyData.map((item, i) => (
              <motion.div
                key={i}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                variants={fadeUp}
                transition={{ duration: 0.4, delay: i * 0.1 }}
                className={`max-w-[220px] text-center ${
                  item.position === "bottom" ? "translate-y-28" : ""
                }`}
              >
                <div className="w-24 h-24 bg-[#0A1F8F] text-white rounded-full flex items-center justify-center text-xl font-bold mx-auto mb-5">
                  {item.year}
                </div>

                <h4 className="font-semibold text-[#1F2F8F]">{item.title}</h4>

                <p className="text-sm text-gray-600 mt-2 leading-7">
                  {item.desc}
                </p>
              </motion.div>
            ))}
          </div>
        </div>

        {/* MOBILE */}
        <div className="lg:hidden space-y-10 px-5">
          {historyData.map((item, i) => (
            <div key={i}>
              <div className="w-20 h-20 bg-[#0A1F8F] text-white rounded-full flex items-center justify-center text-lg font-bold mx-auto mb-4">
                {item.year}
              </div>

              <h4 className="font-semibold text-[#1F2F8F]">{item.title}</h4>

              <p className="text-sm text-gray-600 mt-2 leading-7">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </section>

      {/* ================= STATS ================= */}
      <section
        className="py-16"
        style={{
          backgroundImage: "url('/Map-1.jpg')",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center top",
          backgroundSize: "contain",
        }}
      >
        <div className="max-w-6xl mx-auto px-5 grid grid-cols-2 md:grid-cols-4 gap-10 text-center">
          {statsData.map((item, i) => (
            <motion.div
              key={i}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={fadeUp}
              transition={{ duration: 0.4, delay: i * 0.1 }}
            >
              <h3 className="text-4xl font-bold text-[#1F2F8F]">
                {item.value}
              </h3>

              <p className="text-gray-600 mt-3 leading-6">{item.label}</p>
            </motion.div>
          ))}
        </div>
      </section>

      {/* ================= CTA ================= */}
      <section className="bg-gradient-to-r from-[#1F2F8F] to-[#E91E63] py-16">
        <div className="max-w-7xl mx-auto px-6 flex flex-col lg:flex-row items-center justify-between gap-8 text-white">
          <h2 className="text-2xl lg:text-3xl font-semibold text-center lg:text-left">
            Have Questions? We Are Here To Help You!
          </h2>

          <div className="text-6xl font-bold opacity-20">24/7</div>

          <a
            href="/contact"
            className="bg-[#E91E63] px-8 py-3 rounded-full font-semibold hover:scale-105 transition-all duration-300"
          >
            Contact Us
          </a>
        </div>
      </section>
    </main>
  );
}
